module.exports = __webpack_public_path__ + "media/images/hot_tag-8609a1aebb0ce6a946c94f638fa6db05.png";